import React, { useEffect, useMemo, useState } from "react";
import NotificationsIcon from '@material-ui/icons/Notifications';
import moment from "moment";
import { useSelector } from "react-redux";
import OutSideClose from "components/OutsiteClose";

export default () => {
    const [isOpen, setIsOpen] = useState(false);
    const [notifications, setNotifications] = useState([])
    const { notification } = useSelector(state => state);

    useEffect(() => {
        if (["error", "success"].includes(notification.type)) {
            let _notifications = [...notifications];
            _notifications.unshift({
                message: notification.message,
                time: new Date(),
                isRead: false,
                type: notification.type
            });
            setNotifications(_notifications);
        }
    }, [notification]);
    const [countNotifi, setCountNotifi] = useState(notifications.filter(item => !item.isRead).length);

    useEffect(() => {
        let count = notifications.filter(item => !item.isRead).length;
        setCountNotifi(count);
    }, [notifications])

    return (
        useMemo(() => (
            <OutSideClose onClickOutside={() => {
                setIsOpen(false);
            }}>
                <div style={{ marginRight: 10, position: "relative" }} >
                    <div style={{ position: "relative", cursor: "pointer" }} onClick={() => {
                            setIsOpen(!isOpen);
                            setNotifications(notifications.map(item => {
                                item.isRead = true;
                                return item;
                            }))
                        }}>
                        <NotificationsIcon />
                        {
                            countNotifi ? <span style={{
                                display: "inline-block", /* Ensures it respects width/height and remains inline */
                                width: 15,           /* Diameter of the circle */
                                height: 15,          /* Diameter of the circle */
                                borderRadius: "50%",    /* Makes the element a circle */
                                backgroundColor: "#3498db", /* Set your desired background color */
                                position: "absolute",
                                right: "-2px",
                                bottom: 3,
                                fontSize: 12,
                                fontWeight: 300,
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                display: "block",
                                textAlign: "center"
                            }}>
                                {countNotifi}
                            </span> : <></>
                        }
                    </div>
                    {
                        isOpen && <div style={{
                            height: "90vh",
                            width: 350,
                            backgroundColor: "#f4f4f7fa",
                            position: "absolute",
                            right: 0,
                            borderRadius: 5,
                            padding: 10,
                            display: "flex",
                            flexDirection: "column",
                            gap: 10,
                            color: "black",
                            overflowY: "auto",
                            border: "1px solid #ddd"
                        }}>
                            {
                                notifications.map(item => (
                                    <p style={{ color: item.type == "success" ? "green" : "red" }} >{moment(item.time).format('DD/MM/YYYY HH:mm')} - {item.message}</p>
                                ))
                            }
                        </div>
                    }
                </div>
            </OutSideClose>

        ), [notifications, countNotifi, isOpen])
    )
}